export const stripHTMLFromContent = (text) => {
  return text.replace(/<[^>]*>/g, '').trim()
}

export const updateInternalURLsToURIs = (text, baseURL) => {
  var result = text
  result = result.replace(/\"\/DetailView.aspx\?cid=/gi,'\"' + baseURL + '\/\#\/content\/')
  result = result.replace(/\"DetailView.aspx\?cid=/gi,'\"' + baseURL + '\/\#\/content\/')
  result = result.replace(/\"\/content.aspx\?id=/gi,'\"' + baseURL + '\/\#\/content\/')
  result = result.replace(/\"content.aspx\?id=/gi,'\"' + baseURL + '\/\#\/content\/')
  result = result.replace(/\"https:\/\/www.mlex.org\/permalink\//gi,'\"' + baseURL + '\/\#\/content\/')
  result = result.replace(/\"https:\/\/www.mlex.net\/permalink\//gi,'\"' + baseURL + '\/\#\/content\/')
  result = result.replace(/\"https:\/\/www.mlex.com\/permalink\//gi,'\"' + baseURL + '\/\#\/content\/')
  result = result.replace(/\"https:\/\/cms.mlex.com\/permalink\//gi,'\"' + baseURL + '\/\#\/content\/')
  result = result.replace(/\"https:\/\/cms.mlex.cloud\/permalink\//gi,'\"' + baseURL + '\/\#\/content\/')
  return result
}

export const addReferrerToSeeHereLinks = (text) => {
  var result = text
  result = result.replace(/">here<\/a>/g, '?referrer=content_seehereview">here</a>')
  return result
}

export const addTargetToLinks = (text) => {
  var result = text
  result = result.replace(/<a href="/gi,'<a target="_blank" href=\"')
  return result
}

export const numberWithCommas = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const updateRelativeURIsToFullURLs = (text, baseURL) => {
  var result = text
  result = result.replace(/ href="#/gi,' href=\"' + baseURL + '\/#')
  result = result.replace(/ href="\/#/gi,' href=\"' + baseURL + '\/#')
  result = result.replace(/ href='#/gi,' href=\'' + baseURL + '\/#')
  result = result.replace(/ href='\/#/gi,' href=\'' + baseURL + '\/#')
  return result
}

export const stringToSEO = (input) => { 
  const pattern = /[^\p{L}\p{N}]/gu  
  let tmp = input.replace(/<span class='search-term-highlight'>(.+?)<\/span>/gi, "$1");
  tmp = tmp.replace(pattern, ' ')
  tmp = tmp.trim().replace(/\s+/g, '-').toLowerCase()

  const specialCharsMap = {
    'é': 'e', 'è': 'e', 'ê': 'e', 'ë': 'e',
    'à': 'a', 'â': 'a', 'ä': 'a',
    'û': 'u', 'ù': 'u', 'ü': 'u',
    'î': 'i', 'ï': 'i',
    'ô': 'o', 'ö': 'o', 'ò': 'o',
    'ç': 'c',    
    'á': 'a', 'é': 'e', 'í': 'i', 'ó': 'o', 'ú': 'u',
    'ü': 'u', 'ñ': 'n',
    'ä': 'ae', 'ö': 'oe', 'ü': 'ue', 'ß': 'ss',
    'α': 'a', 'β': 'b', 'γ': 'g', 'δ': 'd', 'ε': 'e', 'ζ': 'z', 'η': 'h', 'θ': 'th', 'ι': 'i', 'κ': 'k', 'λ': 'l', 'μ': 'm',
    'ν': 'n', 'ξ': 'x', 'ο': 'o', 'π': 'p', 'ρ': 'r', 'ς': 's', 'σ': 's', 'τ': 't', 'υ': 'y', 'φ': 'f', 'χ': 'ch', 'ψ': 'ps', 'ω': 'o',
    'æ': 'ae', 'Æ': 'AE',
    'ø': 'o',  'Ø': 'O',
    'å': 'a',  'Å': 'A'
  };

  return tmp.split('').map(char => specialCharsMap[char] || char).join('');
}
